(function ($) {
    $(function () {

        // Header fix for the on scroll event.
        $(window).on('scroll', function () {
            amountscrolled();
        });

        // Cookie.
        $('.cn-revoke-cookie').on('click', function () {
            document.cookie = "cookie_notice_accepted= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
            window.location.reload();
        });

        // Extra product options customize.
        $('.tmcp-checkbox').on('click', function () {
            var element = $(this).parent().parent().parent().parent().parent().parent();
            if (element.find('.tm-qty').hasClass('ignore')) {
                element.find('.minus').prop('disabled', false);
                element.find('.plus').prop('disabled', false);
            } else {
                element.find('.minus').prop('disabled', true);
                element.find('.plus').prop('disabled', true);
            }
        });

        $('.tc-element-container').on(
            'click',
            'input.plus, input.minus',
            function () {
                // Get current quantity values
                var qty = $(this).parent().find('.tm-qty');
                var val = parseFloat(qty.val());
                var max = parseFloat(qty.attr('max'));
                var min = parseFloat(qty.attr('min'));
                var step = parseFloat(qty.attr('step'));

                // Change the value if plus or minus
                if ($(this).is('.plus')) {
                    if (max && (max <= val)) {
                        qty.val(max);
                    } else {
                        qty.val(val + step);
                    }
                } else {
                    if (min && (min >= val)) {
                        qty.val(min);
                    } else if (val > 1) {
                        qty.val(val - step);
                    }
                }

                qty.trigger('change');

            }
        );

        if (!klg_data.is_cart && !klg_data.is_checkout) {
            $('.wd-header-cart > a').on('click', function () {
                if (!$('body').find('.woodmart-close-side').hasClass('woodmart-close-side-opened')) {
                    $('body').find('.woodmart-close-side').addClass('woodmart-close-side-opened');
                }
            });
        }

        if (!klg_data.is_user_logged_in) {
            $('.wd-header-my-account > a').on('click', function () {
                if (!$('body').find('.woodmart-close-side').hasClass('woodmart-close-side-opened')) {
                    $('body').find('.woodmart-close-side').addClass('woodmart-close-side-opened');
                }
            });
        }

        // Remove background.
        $('.close-side-widget > a').on('click', function () {
            if ($('body').find('.woodmart-close-side').hasClass('woodmart-close-side-opened')) {
                $('body').find('.woodmart-close-side').removeClass('woodmart-close-side-opened');
            }
        });

        const mutationObserver = new MutationObserver(callback);
        mutationObserver.observe(document.getElementsByClassName('cart-widget-side')[0], { attributes: true });

        /**
         * Callback function for DOM mutations.
         *
         * @param {object} mutationsList List of DOM mautations.
         */
        function callback(mutationsList) {
            mutationsList.forEach((mutation) => {
                let classes = mutation.target.classList.value;
                if (classes.indexOf('wd-opened') >= 0) {
                    if (!$('body').find('.woodmart-close-side').hasClass('woodmart-close-side-opened')) {
                        $('body').find('.woodmart-close-side').addClass('woodmart-close-side-opened');
                    }
                }
            });
        }

        /**
         * Calculate the amount scrolled.
         */
        function amountscrolled() {
            var winheight = jQuery(window).height();
            var docheight = jQuery(document).height();
            var scrollTop = jQuery(window).scrollTop();
            var trackLength = docheight - winheight;
            var pctScrolled = Math.floor(scrollTop / trackLength * 100);
            // gets percentage scrolled (ie: 80 NaN if tracklength == 0).
            if (scrollTop >= 52) {
                jQuery('.whb-header').addClass('whb-sticked');
            }
            if (scrollTop < 52) {
                jQuery('.whb-header').removeClass('whb-sticked');
            }
        }

        /**
         * Toggle coupon form in and out of display on cart page with slide animation.
         */
        function attachCouponToggleListener() {
            $(".woocommerce-cart .showcoupon").off("click").on(
                "click",
                function (e) {
                    e.preventDefault();
                    const $coupon = $(".coupon");
                    if ($coupon.is(":hidden")) {
                        $('.woocommerce-message').remove();
                        $coupon.slideDown(300, function() { // Slide down
                            $(this).css('display', 'flex'); // Set display to flex after slide down
                        });// Slide down and set display to flex
                    } else {
                        $coupon.slideUp(300, function() { // Slide up and hide
                            $(this).hide();
                        });
                    }
                    return false;
                }
            );
        }

        // Attach the listener initially.
        attachCouponToggleListener();

        /**
         * Re-attach the coupon toggle listener after cart updates.
         */
        $(document.body).on('updated_wc_div', function () {
            attachCouponToggleListener();
        });

    });
})(jQuery);